import { defineStore } from "pinia";
import axios from "axios";
import { getApiUrl } from "../api.js";

export const useChatStore = defineStore("chat", {
  getters: {
    chatId: (state) => state.chat._id,
  },
  state: () => ({
    chats: [],
    chat: {},
    drawer: true,
    loadingChatId: null,
    fetchingChat: false,
    waitingForAssistantMessage: false,
    initNewChat: 0,
  }),
  actions: {
    async fetchChats() {
      try {
        const resp = await axios.get(`${getApiUrl()}/chats`, { withCredentials: true });
        this.chats = resp.data.chats;
        return resp;
      } catch (error) {
        console.log(error);
      }
    },
    async fetchChat(chatId) {
      try {
        this.fetchingChat = true;
        const resp = await axios.get(`${getApiUrl()}/chats/${chatId}`, { withCredentials: true });
        this.chat = resp.data.chat;
        this.fetchingChat = false;
        return resp;
      } catch (error) {
        this.fetchingChat = false;
        console.log(error);
        throw error;
      }
    },
    async sendMessage(chatId, message) {
      try {
        const resp = await axios.post(`${getApiUrl()}/chats/${chatId}`, { message }, { withCredentials: true });
        return resp;
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    async removeChat(chatId) {
      try {
        const resp = await axios.delete(`${getApiUrl()}/chats/${chatId}`, { withCredentials: true });

        const chatIndex = this.chats.findIndex((e) => e._id === chatId);
        if (chatIndex > -1) this.chats.splice(chatIndex, 1);

        return resp;
      } catch (error) {
        console.log(error);
      }
    },
    processNewChatData(data) {
      try {
        this.chat = data.chat;
        this.chats.push(data.chat);
        return;
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
  },
});
